import React, { useState } from "react";
import { IconButton } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import colors from "@/main/style/colors";

import { SpinnerLoading } from "@/main/components/shared/styles";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";

import { DynamicReportGridResponse } from "@/main/models/response/dynamicReportResponse";
import * as S from "./styles";
import ModalExportDynamicReport from "../modalExportDynamicReport/modalExportDynamicReport";
import { useNavigate } from "react-router-dom";
import { RoutesConstants } from "@/main/routes/routesConstants";
import useKogControlElementId from "@/main/hooks/useKogControlElementId";
import { Controls } from "@/main/services/constants/constantsControl";

interface IActionsDynamicReportProps {
	dynamicReport: DynamicReportGridResponse;
	refreshGrid: () => void;
}

interface IActionProps {
	id: string;
	icon: any;
	color: string;
	isLoading: boolean;
	tooltip: string;
	showIcon: boolean;
	onClick?: () => void;
}
const BaseAction = (action: IActionProps) => {
	if (!action.showIcon) return null;
	if (action.isLoading) return <SpinnerLoading />;

	return (
		<React.Fragment>
			<TooltipComponent key={action.id} placement="top" title={action.tooltip}>
				{isNullUndefined(action.onClick) ? (
					<action.icon style={{ color: action.color }} />
				) : (
					<IconButton id={action.id} disabled={action.isLoading} onClick={action.onClick}>
						<action.icon style={{ color: action.color }} />
					</IconButton>
				)}
			</TooltipComponent>
		</React.Fragment>
	);
};
function ActionsDynamicReport({ dynamicReport }: IActionsDynamicReportProps) {
	const navigate = useNavigate();
	const [isOpenModalExport, setIsOpenModalExport] = useState(false);
	const SHOW_EDIT = useKogControlElementId(Controls.idCreateEditDinamicReport);

	function onClickEdit() {
		navigate(`${RoutesConstants.reportDynamicReportRegister}?guidDynamicReport=${dynamicReport.guidDynamicReport}`);
	}

	function onClickExport() {
		setIsOpenModalExport(true);
	}

	const ID_SCREEN = "id-dynamic-report";
	const generateId = (action: string) => `${ID_SCREEN}-${action}`;

	const MAP_BUTTONS_ACTIONS = [
		{
			id: generateId("btn-edit"),
			icon: CreateIcon,
			color: colors.icon,
			isLoading: false,
			tooltip: getTranslateByKey("information.edit"),
			showIcon: SHOW_EDIT,
			onClick: () => onClickEdit(),
		},
		{
			id: generateId("btn-dynamic-filters"),
			icon: TrendingUpIcon,
			showIcon: true,
			color: colors.icon,
			isLoading: false,
			tooltip: getTranslateByKey("information.filters"),
			onClick: () => onClickExport(),
		},
	];

	return (
		<S.Container>
			{MAP_BUTTONS_ACTIONS.map((action) => (
				<BaseAction key={action.id} {...action} />
			))}

			<ModalExportDynamicReport
				dynamicReport={dynamicReport}
				guidDynamicReport={dynamicReport.guidDynamicReport}
				isOpenModal={isOpenModalExport}
				setIsOpenModal={setIsOpenModalExport}
				closeModal={() => setIsOpenModalExport(false)}
			/>
		</S.Container>
	);
}

export default ActionsDynamicReport;
